module.exports = __webpack_public_path__ + "src/assets/images/d1.png";